import React, {useState} from 'react'

import {useHistory} from 'react-router-dom'

import {setPathForRouter} from "@common-helpers/set-rout-path"

import {getAnimationDurationClassName} from "@common-helpers/get-animation-duration-class-name"

import {Logo} from '@common-layout-components/logo'

import {QuestionnaireNav} from "@common-ui/questionnaire-nav"
import {BubbleTitle} from "@common-layout-components/bubble-title"

import messageLayoutsReplacer from 'message-layouts-replacer';

function ucFirst(str) {
    if (!str) return str;

    return str[0].toUpperCase() + str.slice(1);
}


export const LinkQuestion = ({
                                radioPagesConfigNewLayer = null,
                                title = 'заголовок',
                                nextRout,
                                prevRout,
                                nextPageId,
                                prevPageId,
                                componentName,
                                answersOnQuestions,
                                setAnswersOnQuestions,
                                additionalClasses = '',
                                bubbleTitle = 'Заголовок',
                                bubbleSubtitle = 'Под заголовок если нужен, если нет ставим false',
                                options = [],
                                onClick = () => true
}) => {

    
    const isNextPageDisabled = answersOnQuestions[componentName] === null,
          animationDurationClassName = getAnimationDurationClassName(),
          {
            units,
            needWeightKg,
            needWeightLb,
            Age,
            Sex
          } = answersOnQuestions,
          history = useHistory(),
          clickHandler = () => {
              onClick()
              setPathForRouter(nextRout, nextPageId, false, history)
          },
          arrayForReplace = [
              {
                searchLayout: '{whoSex}',
                valueToReplace: Sex === 'woman' ? 'женщинам' : 'мужчинам'
              },
              {
                  searchLayout: '{age}',
                  valueToReplace: Age.replace('i', '')
              },
              {
                  searchLayout: '{goalWeigh}',
                  valueToReplace: units === 'mt' ? `${needWeightKg} кг` : `${needWeightLb} фунт`
              }
          ],
          titleBub = messageLayoutsReplacer(bubbleTitle, arrayForReplace),
          subtitleBub = messageLayoutsReplacer(bubbleSubtitle, arrayForReplace)

    return (<div className={`content ${animationDurationClassName} ${additionalClasses}`} >

        <Logo />

        <div className={`content__inner`}>
            <BubbleTitle title={titleBub} subtitle={ucFirst(subtitleBub)} />

            <div className={`choice`}>
                {options && Array.isArray(options) ? options.map(({label}) => (<div className={'link-question'} onClick={clickHandler} >
                    {label}
                </div>)) : null}
            </div>

        </div>
    </div>)

}
